"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listSites = void 0;
const sites_1 = require("@/services/sites");
const sites_2 = require("@/store/ducks/sites");
const systems_1 = require("@/services/systems");
function listSites() {
    return (dispatch) => {
        dispatch((0, sites_2.getSites)());
        return (0, sites_1.getSites)()
            .then(async (sites) => {
            const siteListItems = sites.map((site) => {
                return {
                    id: site.id,
                    name: site.name,
                    systemsList: site.systems.map((system) => ({
                        ...system,
                        siteName: site.name,
                        siteId: site.id,
                    })),
                };
            });
            await Promise.all(siteListItems.map((site) => {
                return site.systemsList.map(async (system) => {
                    dispatch((0, sites_2.listSiteSystemsProducts)({
                        siteId: site.id,
                        systemId: system.id,
                    }));
                    await (0, systems_1.getSystemProducts)(system.id)
                        .then(async (response) => {
                        const products = response.slice(0, 3);
                        await dispatch((0, sites_2.addProductsToSystems)({
                            siteId: site.id,
                            systemId: system.id,
                            products,
                        }));
                    })
                        .catch(() => {
                        dispatch((0, sites_2.listSiteSystemsProductsError)({
                            siteId: site.id,
                            systemId: system.id,
                        }));
                    });
                });
            }));
            dispatch((0, sites_2.getSitesSuccess)(siteListItems));
        })
            .catch(() => {
            dispatch((0, sites_2.getSitesError)());
        });
    };
}
exports.listSites = listSites;
